import api from '../api';

/**
 * Resolves with the meeting rows, or an empty list on any failure,
 * the join button gets disabled rather than throwing an error into the UI.
 */
const list = ({ commit }, args) => {
  commit('RESET_STATE');
  commit('FETCHING', true);

  return api.list(args)
    .then((response) => {
      commit('FETCH_SUCCESS', true);
      commit('FETCHING', false);
      commit('SET_VALUES', response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      commit('FETCH_SUCCESS', false);
      commit('FETCHING', false);
      commit('FETCH_ERROR', error);
      console.error(error);
      return [];
    });
};

export default {
  list,
};
